export const DEFAULT_ACCOUNT_ID = '';

export const DEFAULT_PERIOD_ID = 0;

export const SEARCH_DELAY = 300;

export const VIEWS = {
  LIST: 'LIST',
  EDIT: 'EDIT',
};
export const BOTH_FILTER = 0;
export const INCOME_FILTER = 1;
export const EXPENSES_FILTER = 2;

export const SELECTED = {
  variant: 'selected',
  icon: 'far fa-check',
};

export const NOT_SELECTED = {
  icon: 'fa',
};
